var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("配置管理")]),
              _c("el-breadcrumb-item", [_vm._v("派单SLA")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("派单SLA")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": _vm.headerStyle,
                "row-class-name": _vm.tableRowClassName
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { prop: "ip3", align: "center", width: "180" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("获取到的tp3")]),
                    _c("div", [_vm._v("字段的值")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                { attrs: { prop: "slaLevel", align: "center", width: "180" } },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("SLAlevel值：PO列表")]),
                    _c("div", [_vm._v('中"工单等级"')]),
                    _c("div", [_vm._v("显示值")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "slaResponse", align: "center", width: "180" }
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("SLAlevel值：PO时效")]),
                    _c("div", [_vm._v('中"响应与分派SLA"显')]),
                    _c("div", [_vm._v("示值")])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { align: "left", "min-width": "400" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "remark-content" },
                            _vm._l(_vm.getNumbers(scope.row.ip3), function(
                              num
                            ) {
                              return _c(
                                "div",
                                { key: num, staticClass: "remark-item" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.findOpDescription(num)) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [_vm._v("备注（tp3的数值的含义）")])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }